// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { isEmptyObject } from "src/app/infrastructure/functions/is-empty-object.function";
import { IImageData, ImageData } from "./image-data";
import { IImageBoxDto, imageBoxDto } from "src/assets/common/models/image-box-dto.g";

export const imageBoxData = {
    guid: 'guid',
    description: 'description',
    fileType_Name: 'fileType_Name',
    folderShardPath: 'folderShardPath',
    inactive: 'inactive',
    deleted: 'deleted',
    photoData: 'photoData',
    photoThumbData: 'photoThumbData',
} as const;

export type TImageBoxData = (typeof imageBoxData)[keyof typeof imageBoxData];

export interface IImageBoxData {
    [imageBoxData.guid]: string | null;
    [imageBoxData.description]: string | null;
    [imageBoxData.fileType_Name]: string | null;
    [imageBoxData.folderShardPath]: string | null;
    [imageBoxData.inactive]: boolean | null;
    [imageBoxData.deleted]: boolean | null;
    [imageBoxData.photoData]: IImageData | null;
    [imageBoxData.photoThumbData]: IImageData | null;
}

export class ImageBoxData
    implements IImageBoxData
{
    [imageBoxData.guid]: string | null = null;
    [imageBoxData.description]: string | null = null;
    [imageBoxData.fileType_Name]: string | null = null;
    [imageBoxData.folderShardPath]: string | null = null;
    [imageBoxData.inactive]: boolean | null = null;
    [imageBoxData.deleted]: boolean | null = null;
    [imageBoxData.photoData]: IImageData | null = null;
    [imageBoxData.photoThumbData]: IImageData | null = null;

    private constructor(
        modelDto?: IImageBoxDto | null,
    ) {
        if (!modelDto || isEmptyObject(modelDto)) return;

        this[imageBoxData.guid] = modelDto[imageBoxDto.guid]
        this[imageBoxData.description] = modelDto[imageBoxDto.description]
        this[imageBoxData.fileType_Name] = modelDto[imageBoxDto.fileType_Name]
        this[imageBoxData.folderShardPath] = modelDto[imageBoxDto.folderShardPath]
        this[imageBoxData.inactive] = modelDto[imageBoxDto.inactive]
        this[imageBoxData.deleted] = modelDto[imageBoxDto.deleted]
        this[imageBoxData.photoData] = ImageData.create(modelDto[imageBoxDto.photoDto]);
        this[imageBoxData.photoThumbData] = ImageData.create(modelDto[imageBoxDto.photoThumbDto]);
    }

    static create(modelDto?: any | null): IImageBoxData | null {
        return modelDto ? new ImageBoxData(modelDto) : null;
    }
}
